import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import SideBarNew from "../../SideBarNew";
import TopBarNew from "../../TopBarNew";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import AppConstants from "../../AppConstants";
import { activesubscription } from "../../redux";
import {
  getActiveTeam,
  getFeaturesPermissions,
  PICSTORK_FEATURES,
} from "../../Teams";
import {
  checkSubscriptionAndStorage,
  addUserAnalytic,
  updateOutTime,
} from "../../ReusableComponents/reusableFunctions";
import Search from "../../Icon/Search.png";
import * as API from "../../api.js";
import TableView from "../../ReusableComponents/TableView/TableView.js";
import Viewbuttons from "../../ReusableComponents/ViewButtons/index.js";
import ButtonWithIcon from "../../ReusableComponents/ButtonWithIcon.js";
import { TowerCard } from "../../ReusableComponents/Tower Card/TowerCard.js";
import LoaderComponent from "../../ReusableComponents/LoaderComponent.js";
import whitePlus from "../../assets/Icons/whiteplus.png";
import CreateTowerPlan from "./CreateTowerPlan.js";
import AddTowerImageSet from "./AddTowerImageSet.js";
import TowerDetailedReport from "./TowerDetailedReport.js";
import TowerImageSlider from "./TowerImageSlider.js";
import NoContent from "../../ReusableComponents/NoContent.js";

const TowerImageSets = (props) => {
  const [user, setUser] = useState({ username: "Guest" });
  const [type, setType] = useState("viewer");
  const [sidebarMode, setSidebarMode] = useState("shrunk");
  const [showBackIcon, setShowBackIcon] = useState(true);
  const [globalState, setGlobalState] = useState({ selectView: "list" });
  const [tableState, setTableState] = useState({ pageSize: 5, pageNumber: 1 });
  const [isLoading, setIsLoading] = useState(false);
  const [projects, setProjects] = useState([]);
  const [imageSliderData, setImageSliderData] = useState(null);
  const [permissions, setPermissions] = useState(null);
  const [completedTasksMap, setCompletedTasksMap] = useState({});
  const [currentView, setCurrentView] = useState("main");
  const [selectedTask, setSelectedTask] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [counts, setCounts] = useState(0);
  const [disabledCards, setDisabledCards] = useState({});
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const location = useLocation();
  const { rowData, breadcrumb } = location?.state || {};
  const history = useHistory();
  const [searchKey, setSearchKey] = useState("");

  function useDebounce(value, delay = 500) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
    return debounced;
  }
  // console.log(location.state, "location");
  const debouncedKey = useDebounce(searchKey, 500);

  useEffect(() => {
    if (!rowData?.id) return;

    const fetchImageCollections = async () => {
      setIsLoading(true);
      try {
        const response = await API.getLatestImageSets(
          "plan",
          100000,
          rowData?.id,
          0,
          "PicStork",
          searchKey
        );

        setProjects(response?.imageCollections);
        setCounts(response.count);
      } catch (err) {
        console.error("Error fetching image collections:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchImageCollections();
  }, [rowData, isCreateModalOpen, debouncedKey]);

  const sidebarConfigurations = {
    options: showBackIcon
      ? [
        { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
        { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
      ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
  };

  const topbarConfigurations = {
    options: showBackIcon
      ? [
        { icon: MenuIcon, text: "Projects", path: "/picstork/towers" },

        ...(breadcrumb || []),

      ]
      : null,
    user,
    type,
    mode: sidebarMode,
    picStorkHelp: true,
    breadcrumb: breadcrumb || [],
  };

  const fetchTasksForProject = async (projectId, planId) => {
    try {
      const response = await API.getAllTask(
        projectId,
        planId,
        " ",
        0,
        1000,
        "PicStork"
      );

      if (response && response.tasks) {
        setTasks(response.tasks);
        return response.tasks;
      }
      return [];
    } catch (err) {
      console.error("Error fetching tasks:", err);
      return [];
    }
  };

  useEffect(() => {
    const fetchProjectDetails = async () => {
      if (!rowData?.project_id) {
        return;
      }
      try {
        const result = await API.getProjectDetailsById(rowData?.project_id);
        if (result) {
          setSelectedProject(result.project);
        }
      } catch (err) {
        console.error("Error fetching project:", err);
      }
    };
    fetchProjectDetails();
  }, [rowData?.project_id]);

  const viewReports = async (row) => {
    try {
      const tasks = await fetchTasksForProject(
        rowData?.project_id,
        rowData?.id
      );

      const completedTasks = tasks.filter(
        (task) =>
          task.image_collection_id === row.id &&
          task.status === AppConstants.TASK.STATUS.COMPLETED
      );

      if (completedTasks.length > 0) {
        const latestTask = completedTasks[0];
        const completeTaskData = await API.getAeroCaptureTask(
          latestTask.task_id
        );

        setSelectedTask(completeTaskData);
        setCurrentView("detailed");
      } else {
        console.error("No completed detection tasks found for this project");
      }
    } catch (err) {
      console.error("Error fetching tasks:", err);
    }
  };

  useEffect(() => {
    if (rowData?.project_id && rowData?.id) {
      fetchTasksForProject(rowData?.project_id, rowData?.id);
    }
  }, []);

  const handleRowClick = async (row) => {
    try {
      const tasks = await fetchTasksForProject(
        rowData?.project_id,
        rowData?.id
      );
      console.log(breadcrumb, "breadcrumb");
      const hasCompletedTask = tasks.some(
        (task) =>
          task.image_collection_id === row.id &&
          task.status === AppConstants.TASK.STATUS.COMPLETED
      );

      if (hasCompletedTask) {
        await viewReports(row);
      } else {
        history.push(`/picstork/upload-tower-images`, {
          rowData: rowData,
          collectionData: row,
          breadcrumb: breadcrumb
        });
      }
    } catch (err) {
      console.error("Error handling row click:", err);
    }
  };

  const changeView = (type, data) => {
    if (type === 1) {
      // Go back to main list view
      setCurrentView("main");
      setSelectedTask(null);
      setSelectedProject(null);
      setImageSliderData(null);
    } else if (type === 3) {
      // Go to image slider/annotation view
      setCurrentView("imageSlider");
      setImageSliderData(data);
    }
  };

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const featuresList = [
          PICSTORK_FEATURES.IMAGECOLLECTIONS,
          PICSTORK_FEATURES.ANNOTATIONS,
          PICSTORK_FEATURES.TASKS,
          PICSTORK_FEATURES.REPORTS,
        ];

        const perms = await getFeaturesPermissions(featuresList);
        setPermissions(perms);
      } catch (error) {
        console.error("Error fetching permissions:", error);
        setPermissions({
          container: "",
          st: "",
          [PICSTORK_FEATURES.REPORTS]: { DOWNLOAD: true },
          [PICSTORK_FEATURES.TASKS]: { READ: true },
        });
      }
    };

    if (user?.username) {
      fetchPermissions();
    }
  }, [user]);

  const handleDetect = async (row) => {
    try {
      setDisabledCards((prev) => ({ ...prev, [row.id]: true }));

      const planId = row?.plan_id;
      const projectId = row?.project_id;
      const projectName = (row?.project_name || "").toString();
      const safeName =
        `${projectName}`.replace(/\s+/g, "").slice(0, 40) || "PicstorkTask";
      const randomTwoDigit = Math.floor(10 + Math.random() * 90);
      const autoName = `${safeName}Task${randomTwoDigit}`;

      const payload = {
        task_name: autoName,
        taskType: "detection",
        project_id: projectId,
        project_name: projectName,
        plan_id: planId,
        state: 2,
        status: AppConstants.TASK.STATUS.CREATING,
        type: [],
      };

      const created = await API.createTask(payload);
      localStorage.removeItem("created_task");
      localStorage.setItem("created_task", JSON.stringify(created.task));

      if (row && row.id) {
        await API.updateTaskDetails(created.task.task_id, {
          state: 3,
          models: [
            {
              "id": "c6f19d35-ecb7-4f2d-91a4-47fa6c37eb33",
              "name": "detectron2_img_Vegetation_encroachment123",
              "usable": true,
              "objects": [
                "Vegetation_encroachment"
              ],
              "display_name": "Tower_Vegetation_encroachment",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T13:05:32.256Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "d05bcde0-a6b8-4a17-aa10-8abfc6e37059",
              "name": "detectron2_img_U_Bolt",
              "usable": true,
              "objects": [
                "U_Bolt"
              ],
              "display_name": "Tower_U_Bolt",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T13:01:54.294Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "aef551d2-7ac2-4941-8a4f-c48a0f208e17",
              "name": "detectron2_img_Suspension_Clamp123",
              "usable": true,
              "objects": [
                "Suspension_Clamp",
                " Suspension_Clamp_Defect"
              ],
              "display_name": "Tower_Suspension_Clamp",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:59:17.393Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "a7b4d03a-43e9-4953-b21f-c42e59c1c36e",
              "name": "detectron2_img_Insulator123",
              "usable": true,
              "objects": [
                "Insulator"
              ],
              "display_name": "Tower_Insulator",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:56:48.858Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "f94ffa6c-f26c-43b8-947b-d9dd94fc1458",
              "name": "detectron2_img_Damper123",
              "usable": true,
              "objects": [
                "Damper"
              ],
              "display_name": "Tower_Damper",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:54:30.112Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "b1f09288-1c63-4718-8114-15ea76356ec5",
              "name": "detectron2_img_Corona_Ring123",
              "usable": true,
              "objects": [
                "Corona_Ring"
              ],
              "display_name": "Tower_Corona_Ring",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:50:38.535Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            },
            {
              "id": "69308950-90fe-445b-853e-5942e3dce1cb",
              "name": "detectron2_img_Foundation123",
              "usable": true,
              "objects": [
                "Foundation ",
                "Foundation_Cracks"
              ],
              "display_name": "Tower_Foundation",
              "user_id": null,
              "source_task": null,
              "date_created": "2025-10-17T12:07:24.983Z",
              "images": null,
              "task_name": null,
              "accuracy": null,
              "size": null
            }
          ],
          collection_id: row?.id,
          task_purpose: "Defect",
          linked_map: created.task.linked_map || null,
          task_parameters: {
            output_type: "BOX",
            measurement_type: null,
            dsm_url: null,
            dtm_url: null,
          },
          fps: created.task.fps || null,
        });

        await API.updateTaskDetails(created.task.task_id, {
          state: 4,
        });

        await API.updateTask(
          created.task.task_id,
          AppConstants.TASK.STATUS.PENDING,
          AppConstants.SERVICES.PICSTORK
        );
      }
    } catch (err) {
      setDisabledCards((prev) => ({ ...prev, [row.id]: false }));
      console.error("Create detection task failed", err);
    }
  };

  return (
    <div className="wrapper">
      <SideBarNew
        config={sidebarConfigurations}
        showMainDashboardIcons={showBackIcon}
        parentSidebarSwitch={() =>
          setSidebarMode(sidebarMode === "shrunk" ? "expanded" : "shrunk")
        }
      />

      <div
        className="right-content"
        style={{ backgroundColor: "#EAEDF0" }}
        onClick={() => setSidebarMode("shrunk")}
      >
        <TopBarNew config={topbarConfigurations} />

        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            marginTop: "20px",
            padding: "20px",
          }}
        >
          {/* Page Header (search, add button etc.) should only show in main view */}
          {currentView === "main" && (
            <div
              className="slide"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
                paddingRight: "25px",
              }}
            >
              <div
                className="services-content-title"
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: "#1F1C45",
                  fontWeight: 600,
                }}
              >
                {rowData?.plan_name} ({counts})
                <ButtonWithIcon
                  text=""
                  icon={whitePlus}
                  onClick={() => setIsCreateModalOpen(true)}
                  isDisabled={false}
                  backgroundColor="#2989CF"
                  border="1px solid #2989CF"
                />
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  paddingRight: "8px",
                }}
              >
                <div style={{ margin: "0px 5px" }}>
                  <img
                    src={Search}
                    style={{
                      height: "20px",
                      width: "20px",
                      position: "relative",
                      left: "25px",
                    }}
                  />
                  <input
                    type="text"
                    value={searchKey}
                    className="add-user-form-text2"
                    placeholder="Search"
                    style={{
                      height: "30px",
                      width: "230px",
                      paddingLeft: "28px",
                      border: "1px solid rgba(102, 102, 102, 0.3)",
                    }}
                    onChange={(e) => setSearchKey(e.target.value)}
                  />
                </div>
              </div>
            </div>
          )}

          {/* Main Conditional Rendering */}
          {currentView === "main" ? (
            isLoading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "50px",
                }}
              >
                <LoaderComponent />
              </div>
            ) : (
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(320px, 320px))",
                  justifyContent: "flex-start",
                  gap: "25px",
                }}
              >
                {projects.length > 0 ? (
                  <>
                    {projects.map((tower) => {
                      // Find all tasks related to this image collection
                      const relatedTasks = tasks.filter(
                        (task) => task.image_collection_id === tower.id
                      );

                      // Determine if any related task has failed
                      const hasFailedTask = relatedTasks.some(
                        (task) =>
                          task.status === AppConstants.TASK.STATUS.FAILED
                      );

                      // Button disabled logic
                      const isDisabled =
                        (relatedTasks.length > 0 && !hasFailedTask) ||
                        disabledCards[tower.id] ||
                        tower?.images_count === "0";

                      return (
                        <TowerCard
                          key={tower.id}
                          title={tower.collection_name}
                          date={new Date(tower.created_on).toLocaleDateString()}
                          onClick={() => handleRowClick(tower)}
                          footerButtonText="Detect"
                          footerButtonDisabled={isDisabled}
                          footerButtonOnClick={() => handleDetect(tower)}
                          info={[
                            {
                              label: "No. of Images - ",
                              value: tower.images_count,
                            },
                            {
                              label: "Detections - ",
                              value: tower.total_detections || "0",
                            },
                          ]}
                        />
                      );
                    })}
                  </>
                ) : (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "transparent",
                      zIndex: 1,
                      pointerEvents: "none",
                    }}
                  >
                    <div style={{ pointerEvents: "auto" }}>
                      <NoContent />
                    </div>
                  </div>
                )}
              </div>
            )
          ) : currentView === "imageSlider" ? (
            <TowerImageSlider
              permissions={permissions}
              data={imageSliderData}
              onClassListUpdated={(classes) => {
                console.log("Classes updated:", classes);
              }}
              changeView={changeView}
            />
          ) : currentView === "detailed" ? (
            <div
              style={{
                padding: "20px",
                backgroundColor: "white",
                borderRadius: "8px",
              }}
            >
              <TowerDetailedReport
                permissions={permissions}
                user={user}
                type={type}
                task={selectedTask}
                plan={rowData}
                project={selectedProject}
                changeView={changeView}
              />
            </div>
          ) : null}
        </div>
      </div>

      <AddTowerImageSet
        isOpen={isCreateModalOpen}
        onRequestClose={() => setIsCreateModalOpen(false)}
        planData={rowData}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

const mapStateToProps = (state) => ({
  SubscriptionData: state.subscription.subscriptionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(TowerImageSets);
